import { render, staticRenderFns } from "./Relic.vue?vue&type=template&id=2274600b"
import script from "./Relic.vue?vue&type=script&lang=js"
export * from "./Relic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports